<script lang="ts">
  import { worldStore, dispatch } from '@sim/store';
  import { SKILL_META, traitById } from '@sim/config';
  import { activeBuilding } from '@sim/world';
  import { topSkill } from '@sim/colonist';
  import { money } from '@sim/selectors';

  $: city = $worldStore;
  $: b = activeBuilding(city)!;
  $: offer = city.recruit;
  $: c = offer?.colonist;
  $: left = offer ? Math.max(0, offer.expiresAt - city.t) : 0;
  $: full = b.colonists.length >= b.maxCrew;
</script>

{#if offer && c}
  <div class="card">
    <div class="top">
      <span class="ic">🧍</span>
      <div class="who">
        <span class="name">{c.name}</span>
        <span class="role">{SKILL_META[topSkill(c)].name} · best skill</span>
      </div>
      <span class="timer mono">{Math.ceil(left)}s</span>
    </div>
    {#if c.traits.length}
      <div class="traits">
        {#each c.traits as t}<span class="trait">{traitById(t)?.name ?? t}</span>{/each}
      </div>
    {/if}
    <div class="acts">
      <button class="no" on:click={() => dispatch({ type: 'dismissRecruit' })}>Pass</button>
      <button class="yes" disabled={city.cash < offer.cost || full} on:click={() => dispatch({ type: 'acceptRecruit' })}>
        {full ? `${b.name} full` : `Recruit to ${b.name} ${money(offer.cost)}`}
      </button>
    </div>
  </div>
{/if}

<style>
  .card {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 70px;
    z-index: 45;
    background: var(--panel);
    border: 1px solid var(--good);
    border-radius: 12px;
    padding: 10px 12px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.5);
    animation: rise 0.25s ease both;
  }
  .top {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ic {
    font-size: 20px;
  }
  .who {
    display: flex;
    flex-direction: column;
  }
  .name {
    font-weight: 800;
    font-size: 14px;
  }
  .role {
    font-size: 11px;
    color: var(--ink-dim);
  }
  .timer {
    margin-left: auto;
    font-size: 11px;
    color: var(--ink-faint);
  }
  .traits {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    margin: 7px 0;
  }
  .trait {
    font-size: 10px;
    padding: 2px 7px;
    border-radius: 999px;
    background: var(--panel-2);
    border: 1px solid var(--line);
    color: var(--ink-dim);
  }
  .acts {
    display: flex;
    gap: 8px;
  }
  .no,
  .yes {
    flex: 1;
    padding: 9px;
    border-radius: 8px;
    font-weight: 700;
    font-size: 12px;
    border: 1px solid var(--line);
    background: var(--panel-2);
    color: var(--ink);
  }
  .yes {
    border-color: var(--good);
    color: var(--good);
  }
</style>
